export enum KitchenType {
    CLOSED = "1",
    KITCHENETTE = "2"
}
export enum KitchenType {
    CLOSED = "1",
    KITCHENETTE = "2"
}
